module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ExportData"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Export Data ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73790040","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportData.vue
// module id = 165
// module chunks = 1